import { Menu, Layout } from "lucide-react";
import React from "react";
import { useLocation } from "react-router-dom";
import UserDropdown from "./UserDropdown";

const formatPageTitle = (pathname: string): string => {
  // Remove '/dashboard/' from the start
  const cleanPath = pathname.replace(/^\/dashboard\//, "");

  // If the path is empty (just '/dashboard'), return 'Dashboard'
  if (!cleanPath) {
    return "Dashboard";
  }

  // Split the path into segments
  const segments = cleanPath.split("/");

  // Handle special cases for direct routes without dashboard
  if (pathname === "/dashboard" || pathname === "/customers") {
    return (
      segments[segments.length - 1].charAt(0).toUpperCase() +
      segments[segments.length - 1].slice(1)
    );
  }

  // Handle single-level dashboard routes
  if (segments.length === 1) {
    return segments[0].charAt(0).toUpperCase() + segments[0].slice(1);
  }

  // For routes with multiple segments (like 'payments/load')
  if (segments.length === 2) {
    // Reverse the order and capitalize
    return (
      segments[1].charAt(0).toUpperCase() +
      segments[1].slice(1) +
      "-" +
      segments[0].charAt(0).toUpperCase() +
      segments[0].slice(1)
    );
  }

  // Fallback
  return "Dashboard";
};

const MerchantHeader: React.FC<{ toggleSidebar: () => void }> = ({
  toggleSidebar,
}) => {
  const location = useLocation();

  const pageTitle = formatPageTitle(location.pathname);

  return (
    <header
      className="bg-gradient-to-r from-white via-red-100 to-[#ED4524] 

 px-4 py-[21.4px] shadow-md"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <button
            onClick={toggleSidebar}
            className="p-1 mr-4 lg:hidden text-black"
          >
            <Menu size={24} />
          </button>
          <div className="flex items-center">
            <Layout className="mr-2 text-black" size={20} />
            <h2 className="text-xl font-semibold text-black">{pageTitle}</h2>
          </div>
        </div>
        <UserDropdown />
      </div>
    </header>
  );
};

export default MerchantHeader;
